import React from 'react';

const SilhouetteWithCrossSVG = ({ className }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 7C17 8.32608 16.4732 9.59785 15.5355 10.5355C14.5979 11.4732 13.3261 12 12 12C10.6739 12 9.40215 11.4732 8.46447 10.5355C7.52678 9.59785 7 8.32608 7 7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7ZM15 7C15 6.20435 14.6839 5.44129 14.1213 4.87868C13.5587 4.31607 12.7956 4 12 4C11.2044 4 10.4413 4.31607 9.87868 4.87868C9.31607 5.44129 9 6.20435 9 7C9 7.79565 9.31607 8.55871 9.87868 9.12132C10.4413 9.68393 11.2044 10 12 10C12.7956 10 13.5587 9.68393 14.1213 9.12132C14.6839 8.55871 15 7.79565 15 7ZM2 20C2 16 4.001 14 8.004 14H11.256C11.256 14.748 11.439 15.415 11.806 16H8C5.333 16 4 17.333 4 20H11.555C11.397 20.317 11.318 20.984 11.318 22H4C2.667 22 2 21.333 2 20ZM15.671 14.257L17.914 16.499L20.156 14.257C20.62 13.777 21.091 13.777 21.571 14.257C22.051 14.737 22.051 15.207 21.571 15.671L19.328 17.914L21.571 20.156C22.042 20.628 22.042 21.099 21.571 21.571C21.099 22.042 20.628 22.042 20.156 21.571L17.914 19.328L15.671 21.571C15.211 22.053 14.739 22.053 14.257 21.571C13.775 21.088 13.775 20.617 14.257 20.156L16.499 17.914L14.257 15.671C13.785 15.201 13.785 14.729 14.257 14.257C14.729 13.785 15.2 13.785 15.671 14.257Z"
            fill="white"
        />
    </svg>
);

export default SilhouetteWithCrossSVG;
